import { render, staticRenderFns } from "./classmange.vue?vue&type=template&id=0cabf06a"
import script from "./classmange.vue?vue&type=script&lang=js"
export * from "./classmange.vue?vue&type=script&lang=js"
import style0 from "./classmange.vue?vue&type=style&index=0&id=0cabf06a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports